import styled from 'styled-components';
import { BREAKPOINT_MEDIUM } from 'global-search-shared';
export const StyledSearchInput = styled.input.withConfig({
  displayName: "StyledSearchInput",
  componentId: "sc-1t8304h-0"
})(["flex-grow:1;outline:none;width:", ";height:", ";font-size:14px !important;text-indent:8px;font-weight:300 !important;-webkit-font-smoothing:antialiased !important;-moz-osx-font-smoothing:antialiased !important;border:0;transition:height 0.1s ease-in,color 0.1s ease-in !important;transform:translateZ(0);will-change:height,color;background:none;color:", ";padding:0 0 0 40px !important;padding-right:", ";@media (max-width:", "px){padding-left:30px !important;}&::placeholder{color:var(--search-icon-fill);}"], ({
  isOpen
}) => !isOpen && '100%', ({
  isOpen
}) => isOpen ? '48px' : '32px', ({
  isOpen,
  theme
}) => !isOpen && `${theme.color['border-core-subtle']} !important`, ({
  hasValue
}) => hasValue && '36px !important', BREAKPOINT_MEDIUM - 1);